import { clearPassengerFilters, setPassengerFilter, setSeatMapFilters } from './actions';
import produce from 'immer';
const initialState = {
    allowedFilters: [],
    activePassengerFilters: []
};
export const seatMapReducer = (state = initialState, action) => {
    switch (action.type) {
        case setSeatMapFilters.toString(): {
            return produce(state, draft => {
                draft.allowedFilters = action.payload;
            });
        }
        case setPassengerFilter.toString(): {
            const restriction = action.payload;
            const activePassengerFilters = state.activePassengerFilters;
            if (activePassengerFilters === null || activePassengerFilters === void 0 ? void 0 : activePassengerFilters.includes(restriction)) {
                return produce(state, draft => {
                    draft.activePassengerFilters = draft.activePassengerFilters.filter(filter => filter !== restriction);
                });
            }
            return produce(state, draft => {
                draft.activePassengerFilters.push(restriction);
            });
        }
        case clearPassengerFilters.toString(): {
            return produce(state, draft => {
                draft.activePassengerFilters = [];
            });
        }
        default:
            return state;
    }
};
